var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"logotype",attrs:{"to":_vm.vueRoutes.logs}},[_c('img',{attrs:{"src":require("@static/branding/logo.png"),"alt":_vm.config.APP_NAME}})])}
var staticRenderFns = []

export { render, staticRenderFns }